import { createFileRoute } from '@tanstack/react-router';

import { BunkerPlanPage } from '../demand/pages/BunkerPlanPage';

export const Route = createFileRoute('/_app/fuel/planning/bunker-plan')({
    component: BunkerPlanPage,
});
